import React from 'react'

export const Preloader = () => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#ffffff',
    zIndex: 99999,
  }}>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '16px'
    }}>
      <div className="spinner-border" style={{ width: '2.5rem', height: '2.5rem', color: '#2e37a4' }} role="status">
        <span className="visually-hidden">Yuklanmoqda...</span>
      </div>
      <span style={{ fontSize: '13px', fontWeight: 600, color: '#64748b', letterSpacing: '0.5px', fontFamily: 'Inter, sans-serif' }}>
        Yuklanmoqda...
      </span>
    </div>
  </div>
)
